import './CustomSwitch.sass'

import * as React from 'react'
import Switch from 'react-switch'

import { CustomSwitchProps } from './'

const CustomSwitch: React.SFC<CustomSwitchProps> = ({ value, onChange }) => (
  <Switch
    className='custom-switch'
    offColor={'#686E6E'}
    onColor={'#1ADDE4'}
    boxShadow={'0 0 1px 1px #b1afaf'}
    activeBoxShadow={'0 0 1px 1px #b1afaf'}
    width={51}
    uncheckedIcon={false}
    checkedIcon={false}
    checked={value}
    onChange={onChange}
  />
)

export default CustomSwitch
